import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { SharePanelMode } from "../../Panels/CMFileSharePanel";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Share20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Share20Regular";
import { ComponentTypes } from "../../../src/taskpane/config/config";

export function useMenuItem_Share(isShareEnabled: boolean, openSharePanel: (mode: SharePanelMode) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const tenantSharingEnabled = useSelector((state: RootState) => state.tenantInfo?.enableSharing);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.at(-1));

  const menuItem_Share = React.useMemo(() => {
    if (isShareEnabled && tenantSharingEnabled && currentDirectory?.type !== ComponentTypes.SharePointList) {
      return {
        key: "share",
        // iconProps: { iconName: "Share" },
        iconProps: {},
        onRenderIcon: () => <Share20Regular className={menuItemIconStyles} />,
        text: `${languageStrings.Share}`,
        onClick: () => openSharePanel(SharePanelMode.Share)
      } as IContextualMenuItem;
    }
    return null;
  }, [isShareEnabled, tenantSharingEnabled, currentDirectory, languageStrings, openSharePanel]);

  return {
    menuItem_Share
  }
}
